"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable max-len */
/* eslint-disable quotes, indent */
var _default = {
  "inputForm.instruction": "Todos los campos son obligatorios a menos que estén marcados como opcionales",
  "inputField.label.firstName": "Primer nombre",
  "inputField.label.lastName": "Apellido",
  "inputField.label.fullName": "Nombre en la tarjeta",
  "inputField.label.Email": "Correo electrónico",
  "inputField.label.phoneNumber": "Número de teléfono",
  "inputField.placeholder.firstName": "Tom",
  "inputField.placeholder.lastName": "Doe",
  "inputField.placeholder.fullName": "Tom Doe",
  "inputField.placeholder.email": "tom.doe@cashstar.com",
  "inputField.placeholder.phoneNumber": "Ingresa número telefónico",
  "inputField.errorMessage.invalidName": "Por favor ingrese un nombre valido",
  "inputField.errorMessage.pleaseEnterAValidFirstName": "Por favor, ingrese un nombre válido",
  "inputField.errorMessage.pleaseEnterAValidLastName": "Por favor ingrese un apellido válido",
  "inputField.errorMessage.pleaseEnterAValidFullName": "Por favor ingrese un nombre completo válido",
  "inputField.errorMessage.invalidAddressValue": "Por favor introduce una dirección válida",
  "inputField.errorMessage.invalidCityValue": "Por favor introduzca una ciudad válida",
  "inputField.errorMessage.incompleteField": "campo incompleto",
  "inputField.errorMessage.exceedsMaxCharacters": "Excede {max} caracteres",
  "inputField.errorMessage.pleaseEnterAValidEmailAddress": "Por favor, introduce una dirección de correo electrónico válida",
  "inputField.errorMessage.pleaseEnterAValidPhoneNumber": "Por favor ingrese un número de teléfono válido",
  "header.text.billingInfo": "Datos de facturación",
  "submitButton.adyen.label": "Pagar ahora",
  "inputField.label.cardNumber": "Número de tarjeta",
  "inputField.label.cardExpiry": "Fecha de caducidad (MM/YY)",
  "inputField.label.cardCVV": "CVV/CVC",
  "inputField.placeholder.cardNumber": "Número de tarjeta",
  "inputField.placeholder.cardExpiry": "MM/AA",
  "inputField.placeholder.cardCVV": "3 o 4 dígitos",
  "inputField.errorMessage.invalidCardNumber": "Por favor, introduzca un número de tarjeta válido",
  "inputField.errorMessage.cardTypeNotSupported": "El tipo de tarjeta no es compatible",
  "inputField.errorMessage.invalidCardExpiry": "Introduce una fecha de caducidad válida",
  "inputField.errorMessage.invalidCardCVV": "Ingrese un CVV o CVC válido",
  "inputField.label.country": "País",
  "inputField.label.zipcode": "Código postal",
  "inputField.label.addressLine": "Dirección Línea 1",
  "inputField.label.addressLineTwo": "Línea de dirección 2 (opcional)",
  "inputField.label.city": "Ciudad",
  "inputField.label.state": "Estado",
  "inputField.placeholder.zipCode": "Código postal",
  "inputField.placeholder.addressLine": "Dirección Línea 1",
  "inputField.placeholder.addressLineTwo": "Línea de dirección 2 (opcional)",
  "inputField.placeholder.city": "Ciudad",
  "inputField.placeholder.state": "Estado",
  "inputField.label.saveCardLabel": "Guardar para más adelante",
  "paymentMethod.paypal.login.initial": "Para completar el pago a través de PayPal, inicie sesión y valide los detalles de pago",
  "paymentMethod.paypal.login.success": "Validación exitosa, complete el pago",
  "inputField.label.makeAsDefaultLabel": "Marcar como predeterminado",
  "paymentMethod.adyen.label": "Tarjeta de crédito y banca electrónica",
  "paymentMethod.adyen.single.label": "Tarjeta de Crédito",
  "paymentMethod.paypal.label": "PayPal",
  "paymentMethod.zippay.label": "Zip",
  "paymentMethod.zipPay.minCartAmount": "El valor mínimo de pedido para usar Zip es de $35",
  "paymentMethod.zipPay.additionalCharges": "Se puede aplicar una tarifa comercial adicional de {amount} para usar Zip",
  "paymentMethod.creditCard.label": "Tarjeta de Crédito",
  "paymentMethod.googlePay.label": "Google Pay",
  "paymentMethod.applePay.label": "Apple Pay"
};
exports.default = _default;